import React from 'react'
import { useState } from 'react';
import { Drawer, Button, Col, DatePicker, Divider, Flex, Form, Image, Row, Space, Typography } from 'antd';
import { MyInput, MySelect } from '../../../components';
import { apiCalls } from '../../../shared/Apis';
const { Text, Title } = Typography

const AddPaymentMethod = ({visible, onClose,projectid }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    const paymentpost = async(formData) => {
        setLoading(true)
        try {
            const result = await apiCalls.PaymentApi.paymentpost(formData)
            setLoading(false);
            if(result)
                form.resetFields()
        } catch (error){
            console.error("Error change password data",error)
        }
    }

    const onFinish = async () => {
        try {
            const formData = await form.validateFields();
            paymentpost(formData);
        } catch (error) {
            console.error("Form validation error:", error);
        }
    };
    const skills = [
        { id: '1', name: 'Stripe' },
        { id: '2', name: 'Paypal' },
    ];
    return (
        <Drawer
        title="Add Account Details"
        onClose={onClose}
        className="drawer"
        open={visible}
        width={500}
        footer={
        <Space className="w-100 right">
            <Button 
                onClick={onClose}
                className="btncancel"
            >
                Cancel
            </Button>
            <Button  
                block
                className='btnsave bg-brand'
                type="primary"
                htmlType="submit"
                loading={loading}
                onClick={()=> form.submit()}
            >
                Save
            </Button>
        </Space>
    }
>
    <Form
        form={form}
        layout="vertical"
        requiredMark={false}
        onFinish={onFinish}
    >
        <Row gutter={16} justify={'center'}>
            <Col span={24}>
            <p>{projectid}</p>
            </Col>
        <Col span={24}>
                    <MyInput
                        name="cardName"
                        label="Card Name"
                        placeholder="Enter Card Name"
                        size='large'
                        value={form.getFieldValue("cardName") || ''}
                    />
                </Col>
                <Col span={24}>
                    <MyInput
                        name="cardNumber"
                        label="Card Number"
                        placeholder="Enter Card Number"
                        size='large'
                        value={form.getFieldValue("cardNumber") || ''}
                    />
                </Col>
                <Col span={24}>
                        <MySelect
                            label="Payment Method"
                            name="paymentMethod"
                            size="large"
                            message="Please enter skills/services"
                            options={skills}
                        />
                    </Col>
                <Col span={24}>
                    <MyInput
                        name="cvc"
                        label="CVC"
                        placeholder="cvc"
                        size='large'
                        value={form.getFieldValue("cvc") || ''}
                    />
                </Col>
                <Col span={24}>
                    <MyInput
                        name="amount"
                        label="Amount"
                        placeholder="Amount"
                        size='large'
                        value={form.getFieldValue("amount") || ''}
                    />
                </Col>
                <Col span={24}>
                    <MyInput
                        name="expYear"
                        label="Expiry Year"
                        placeholder="1110-1111-9878"
                        size='large'
                        type='date'
                        value={form.getFieldValue("expYear") || ''}
                    />
                </Col>
                <Col span={24}>
                    <MyInput
                        name="expMonth"
                        label="Expiry Month"
                        placeholder="1110-1111-9878"
                        size='large'
                        type='date'
                        value={form.getFieldValue("expMonth") || ''}
                    />
                </Col>
        </Row>
    </Form>
</Drawer>
        
    )
}

export {AddPaymentMethod}